import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';
import { sendDataToNewRelic } from './newRelicLoggingUtils';

const { isATCEnabled } = podFulFillmentUtils;
/**
 * @param {string} promoType
 * @returns {string} - Decoded Promotion Type
 */
export const decodePromoType = ({ promoType }) => {
  let decodedPromoType = 'DAY';
  if (promoType === 'pro') decodedPromoType = 'PRO';
  else if (promoType === 'decor') decodedPromoType = 'DECOR';
  return decodedPromoType;
};

/**
 * @param {string} src
 * @param {string} imageSize
 * @returns {string} - Formatted image URL
 */
export const formatImage = ({ src, imageSize }) => {
  return src?.replace('<SIZE>', imageSize);
};

/**
 * @param {*} product
 * @returns {boolean} product is discounted
 */
// export const hasStrikeThrough = (product) => {
//   const { value, original } = product?.pricing || {};
//   return value && value !== original;
// };

/**
 * If this does not completely satisfy sort reqs, then we can add a check for inventoryStatus too.
 * @param {*} first
 * @param {*} second
 * @returns {number} the sort value
 */
export const productSort = (first, second) => {
  return Number(isATCEnabled(second)) - Number(isATCEnabled(first));
};

export const outOfStockCount = (products) => {
  let oosCount = 0;
  products.forEach((product) => {
    if (!isATCEnabled(product)) oosCount += 1;
  });

  return oosCount;
};

export const oosSwapping = (products, backupProducts, oosCount) => {
  const updatedProducts = [...products];

  if (oosCount <= backupProducts.length) {
    updatedProducts.splice(-oosCount);
  }
  if (oosCount > backupProducts.length && (backupProducts.length !== 0)) {
    updatedProducts.splice(-backupProducts.length);
  }

  let replaced = 0;
  for (let i = 0; i < backupProducts.length; i += 1) {
    if (replaced < oosCount) {
      updatedProducts.push(backupProducts[i]);
      replaced += 1;
      backupProducts.splice(i, 1);
      i -= 1;
    }
  }

  updatedProducts.sort(productSort);

  return updatedProducts;
};

export const getBackupIds = (backUpCategories, catId) => {
  const categories = [...backUpCategories];
  const categoryId = 'Backup' + catId;
  let itemIds;
  categories.forEach((backupCat) => {
    if (backupCat?.id?.toLowerCase() === categoryId.toLowerCase()) {
      itemIds = backupCat?.itemIds;
    }
  });
  return itemIds;
};

export const alertIfServerItemOutOfStock = (serverProducts, specialBuyType) => {
  serverProducts.forEach((product) => {
    const { itemId } = product;
    /*
    item is out of stock,
    we send an alert to new relic
    */
    sendDataToNewRelic({
      appName: 'nucleus.promotions',
      actionName: 'server-item-out-of-stock',
      // deal type is either sbotd or sbotw
      dealType: specialBuyType,
      segment: 'Promotions',
      outOfStockItemId: itemId
    });
  });
};

/**
 * requires a DOM
 * confirms if an element meets criteria for "in view"
 * "in view" - element is at least half way up the viewport
 * @param {Element} element
 * @returns {boolean}
 */
export const isInView = (element) => {
  if (!element) return false;
  const halfScreenHeight = window.innerHeight / 2;
  const { top, bottom } = element.getBoundingClientRect();
  return top < halfScreenHeight && bottom >= halfScreenHeight;
};

export const isValidData = (data) => {
  return Boolean(
    data?.specialBuyMetadata?.categoryMetadata[0]?.itemIds?.[0]
  );
};

export const DUAL_PATH_IDENTIFIER = 'SFI_Available';
